module.exports = __webpack_public_path__ + "media/images/ribbon_ug_right-73d8087976bc3c69e6cf311ec3c9609d.svg";